<template>
  <div>
    <div class="box">
      <div>
        <!-- 组件 -->
        <div class="logo">
          <jinanLogo :nameList="nameList"></jinanLogo>
        </div>
      </div>
      <div>
        <span class="hometu">{{ nameList.homeSystemTitle }}</span>
      </div>
      <div>
        <img src="" alt="" />
        <div class="main_user_zoom">
          <el-dropdown @command="select">
            <div class="head-user">
              <div class="head-user-img">
                <img src="@/assets/img/default-head.png" />
              </div>
              <div class="head-user-role">
                {{ $store.state.user.userInfo.nickName }}
                <i class="fa fa fa-caret-down"></i>
              </div>
            </div>
            <!-- 登录 -->
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>用户交接</el-dropdown-item> -->
              <template v-if="!$route.meta.newHome">
                <!-- <el-dropdown-item command="linkto">访问官网</el-dropdown-item> -->
                <el-dropdown-item command="accBind">账号绑定</el-dropdown-item>
                <!--<el-dropdown-item>个人中心</el-dropdown-item>-->
                <el-dropdown-item command="changePass">修改密码</el-dropdown-item>
              </template>
              <template v-if="$store.state.user.userInfo.tongxin">
                <el-dropdown-item command="editTitle">系统名称修改</el-dropdown-item>
              </template>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import jinanLogo from './jinanlogo/jinanLogo.vue';
import { editName } from '@/api/home.js';
export default {
  components: { jinanLogo },
  data() {
    return {
      nameList: [],
      type: 3,
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'name']),
  },
  mounted() {
    this.getList();
  },
  watch: {
    //   nameList: {
    //     // immediate: true,
    //     // deep: true,
    //     handler(val) {
    //       this.getList();
    //     },
    //   },
  },
  methods: {
    changePass() {
      this.showDia = true;
    },
    passSubmit() {
      console.log(this.passForm);
      var { old_pwd, new_pwd, confirm } = this.passForm;
      if (!old_pwd || !new_pwd || !confirm) {
        this.$message.error('请填写必填信息');
        return false;
      } else if (confirm !== new_pwd) {
        this.$message.error('输入的两次密码不相同');
        return false;
      } else if (old_pwd === new_pwd) {
        this.$message.error('新密码不可以与旧密码相同');
        return false;
      }

      this.$post('/user/xiugaimima', this.passForm).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.resetchange();
        this.showDia = false;
        setTimeout(() => {
          this.$store.commit('clearUser');

          this.$router.replace({
            path: '/login',
          });
        }, 1400);
      });
    },
    resetchange(a) {
      this.passForm = { old_pwd: '', new_pwd: '', confirm: '' };
      if (a) {
        this.showDia = false;
      }
    },

    chaneNum(v) {
      var str = Number(v) <= 9 ? `0${v}` : v;
      return str;
    },
    weihu() {
      this.$post('/role/addmaintain', this.weihufm).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
      });
    },
    select(val) {
      this[val]();
    },
    // logout() {
    //   logout({ token: this.$store.state.token }).then((res) => {
    //     this.$store.commit("clearUser");

    //     this.$router.replace({
    //       path: "/login",
    //     });
    //   });
    // },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace({
            path: '/login',
          });
        });
      });
    },
    linkto() {
      window.open('https://www.tongren119.com/');
      // var date = new Date();
      // var time = `${date.getFullYear()}-${this.chaneNum(date.getMonth() + 1)}-${date.getDate()}`;
      // var obj = { user: this.$local.get("account").username, time };
      // this.$post("/website/automaticlogin", obj).then((res) => {
      //   window.open(`http://www.tongren119.com?info=${res}`, "_blank");
      // });
    },
    // 账号绑定
    accBind() {},
    getMenu() {
      this.$post('/menu/thisusermenu').then((res) => {
        this.navList = res.data;
        for (let key in this.navList) {
          this.menuList.push(this.navList[key].menu_href);

          if (this.navList[key].menu_name == '基础设置' && this.$store.state.user.company.cCompanyNum === 'aaa') {
            this.navList[key].tr_power_hson.push(
              {
                menu_name: '执法记录',
                menu_href: 'webview',
                outline: 'https://trtest.tongren119.com/#/login?YXV0b2xvZ2luPTEmdHlwZT0y',
              },
              {
                menu_name: '消防预案',
                menu_href: 'webview',
                outline: 'https://www.anfangxing.cn/shandong/index.html#!/commanding/a15cdf66-00e0-4dbe-8d6f-654d9d7caa66/a1b3b4d1-c0d8-49c3-9b07-dde379ea09a1',
              },
            );
          }

          if (this.navList[key].tr_power_hson) {
            this.navList[key].tr_power_hson.forEach((menu) => {
              this.menuList.push(menu.menu_href);
            });
          }
        }
      });
      this.$post('/menu/findall', { page: 1, limit: 100 }).then((res) => {
        // console.log(res.data)
        let arr = res.data.list;
        for (let key in arr) {
          this.allList.push(arr[key].menu_href);
        }
        this.checkRouter(this.$route.path);
      });
    },
    editTitle() {
      this.$router.push('/editTitle');
    },
    getList() {
      editName({ type: this.type }).then((res) => {
        console.log(res);
        this.nameList = res.data;
      });
    },
  },
};
</script>
<style lang="scss">
.logo {
  position: relative;
  top: 4px;
  left: -280px;
}
.box {
  position: relative;
  .hometu {
    position: absolute;
    width: 50%;
    height: 40%;
    top: 90%;
    left: 24%;
    transform: translate(-50% -50%);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 10.38px;
    line-height: 0px;
    color: #34e8f5;
    text-align: center;
    // 登录样式
    // background-image:url(https://img.js.design/assets/img/62e78a0037a312ea142c79f6.png);
    vertical-align: top;
    // margin-right: 20%;
  }
  color: #f0efef;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 90px;
  // 蒙层
  //   background-color: #715c33;
  width: 1640px;
  justify-content: space-around;
  align-items: center;
  margin: auto;
  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      position: relative;
      font-size: 16px;
      .user-avatar {
        cursor: pointer;
        width: 34px;
        height: 34px;
        object-fit: cover;
        vertical-align: middle;
        border-radius: 17px;
        margin-right: 5px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>
